interface CreateRecruitmentModalProps {
  onClose: () => void;
}

const CreateRecruitmentModal = ({ onClose }: CreateRecruitmentModalProps) => {
  const handleSubmit = () => {
    alert("募集が投稿されました！");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">📢 メンバー募集を作成</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              募集ポジション
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>ボーカル</option>
              <option>ギター</option>
              <option>ベース</option>
              <option>ドラム</option>
              <option>キーボード</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              スキルレベル
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>初心者OK</option>
              <option>中級者以上</option>
              <option>上級者のみ</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              活動頻度
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>週1回</option>
              <option>週2-3回</option>
              <option>月2-3回</option>
              <option>不定期</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              募集内容
            </label>
            <textarea
              placeholder="募集の詳細を入力"
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-20 resize-none"
            />
          </div>
        </div>
        <div className="flex space-x-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            キャンセル
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 gradient-bg text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity"
          >
            投稿する
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRecruitmentModal;
